<div class="search-file-name">
  <a
    href="javascript:void(0);"
    tabindex="0"
    *ngIf="isFile"
    (click)="showPreview($event)"
    (keydown.enter)="showPreview($event)"
    (keyup.enter)="showPreview($event)"
    class="aca-link aca-crop-text"
    [title]="nameStripped"
    [innerHTML]="name$ | async"
  ></a>
  <a
    href="javascript:void(0);"
    tabindex="0"
    *ngIf="!isFile"
    (click)="navigate($event)"
    (keyup.enter)="navigate($event)"
    (keydown.enter)="navigate($event)"
    class="bold aca-link aca-crop-text"
    [title]="nameStripped"
    [innerHTML]="name$ | async"
  ></a>
  <span
    data-automation-id="search-results-entry-title"
    class="aca-crop-text"
    [title]="titleStripped"
    [innerHTML]="title$ | async"
  ></span>
</div>
<div
  data-automation-id="search-results-entry-description"
  class="aca-crop-text"
  [title]="descriptionStripped"
  [innerHTML]="description$ | async"
></div>
<div class="aca-result-location">
  <aca-location-link
    [context]="context"
    [showLocation]="true"
  ></aca-location-link>
</div>
<div
  class="aca-result-content aca-crop-text"
  [title]="contentStripped"
  [innerHTML]="content$ | async"
></div>
